// src/types/trading.ts
export enum BrokerType {
  XM = 'XM',
  WELTRADE = 'WELTRADE'
}

export interface TradingAccount {
  id: string;
  userId: string;
  accountNumber: string;
  accountName: string;
  server: string;
  platform: string;
  isConnected: boolean;
  createdAt: Date;
  updatedAt: Date;
  brokerType: BrokerType;
  strategies?: StrategySubscription[];
  metaApiAccountId?: string;
  serverName?: string;
  state?: string;
}

export interface AccountInfo {
  balance: number;
  equity: number;
  currency: string;
  leverage: number;
  marginLevel: number;
  name: string;
  login: string;
  platform: string;
  server: string;
  [key: string]: any;
}

export interface Position {
  id: string;
  symbol: string;
  type: string;
  volume: number;
  openPrice: number;
  currentPrice: number;
  profit: number;
  time: string;
  [key: string]: any;
}

export interface Strategy {
  id: string;
  name: string;
  description: string;
  brokerType: BrokerType;
  minBalance: number;
  maxBalance: number;
  isActive: boolean;
  createdAt: any; // Firestore timestamp
  updatedAt: any; // Firestore timestamp
  metaApiId?: string;
}

export interface StrategySubscription {
  id: string;
  accountId: string;
  strategyId: string;
  tradeVolume: number;
  isActive: boolean;
  createdAt: any; // Firestore timestamp
  updatedAt: any; // Firestore timestamp
}

export interface TradeSize {
  mode: "fixedVolume";
  tradeVolume: number;
}

export interface Subscription {
  _id?: string;
  strategyId: string;
  accountId: string;
  name?: string;
  multiplier?: number;
  tradeSizeScaling?: {
    tradeVolume: number;
  };
  copyStopLoss?: boolean;
  copyTakeProfit?: boolean;
  allowedSides?: string[];
  strategy?: Strategy;
  [key: string]: any;
}

export interface SubscriberInfo {
  _id: string;
  accountId: string;
  name?: string;
  subscriptions: Subscription[];
  [key: string]: any;
}

export interface TradingHistoryItem {
  id: string;
  time: string;
  type: string;
  symbol?: string;
  volume?: number;
  price?: number;
  profit?: number;
  entryType?: string;
  [key: string]: any;
}